import React, { useRef } from "react";
import Slider from "react-slick";
import Loader from "../../Loader";
import { useDispatch, useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import {
  setExternalLink,
  setShowExternalPopup,
} from "../../../redux/slice/slicePopup";
import SliderNavigation from "../../SliderNavigation";
import { imageUrl } from "../../../constants/constants";

function BottomSlider() {
  const slider = useRef();

  const dispatch = useDispatch();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: footerLinksData = [], footerLinksIsLoading } =
    useGetProtectedApiDataQuery({
      url: "gov_website_link",
      lang: languageType,
    });

  const handlePopupLink = (link) => {
    dispatch(setShowExternalPopup(true));
    dispatch(setExternalLink(link));
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  if (footerLinksIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="gov-logo-area" aria-label="Government website links">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
              <div>
                <Slider {...settings} ref={slider}>
                  {footerLinksData.map((item, index) => (
                    <React.Fragment key={index}>
                      <button
                        className="gov-logo-button"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePopupLink(item.field_extenral_link);
                        }}
                      >
                        <img
                          src={imageUrl + item?.field_image_gov}
                          alt={item.title}
                        />
                      </button>
                    </React.Fragment>
                  ))}
                </Slider>
              </div>
              <div className="gov-slider">
                <SliderNavigation slider={slider} section={"Government Link"} />
              </div>
            </div>
          </div>
        </div>

        {/* <div className="gov-box">
          <div className="arrowGallery3">
            <span className="left" onClick={prev}>
              <i className="fa fa-angle-left"></i>
            </span>
            <span className="right" onClick={next}>
              <i className="fa fa-angle-right"></i>
            </span>
          </div>
        </div> */}
      </div>
    </>
  );
}

export default BottomSlider;
